import { Box } from '@mui/material';
import React from 'react';

import { cardDimensionsMedia } from '../../assets/styles/themes/tokens';

const SummaryContainer: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => (
	<Box
		sx={{
			display: 'flex',
			width: '100%',
			maxWidth: cardDimensionsMedia.desktop.maxWidth,
			flexDirection: 'column',
		}}
		data-testid="summary-container"
	>
		{children}
	</Box>
);

export default SummaryContainer;
